
import React from "react";
import { ReliabilityBadge } from "@/components/ui/reliability-badge";

interface PageTitleProps {
  title: React.ReactNode;
  description: string;
  reliabilityLevel?: 1 | 2 | 3 | 4 | 5;
}

export const PageTitle = ({ title, description, reliabilityLevel }: PageTitleProps) => {
  return (
    <>
      {title && (
        <div className="flex items-center justify-between mb-2">
          <h1 className="text-xl sm:text-2xl font-bold">{title}</h1>
          {reliabilityLevel && <ReliabilityBadge level={reliabilityLevel} showLabel={true} />}
        </div>
      )}
      {description && <p className="text-gray-600 mb-6 text-sm sm:text-base">{description}</p>}
    </>
  );
};
